"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allGlobalEventNames = allGlobalEventNames;
exports.getGlobalEvent = getGlobalEvent;
exports.getGlobalEventOrThrow = getGlobalEventOrThrow;
const eventJson = require("@/genfiles/events.json");
const events = new Map();
eventJson.forEach((card) => {
    events.set(card.name, card);
});
function allGlobalEventNames() {
    return events.keys();
}
function getGlobalEvent(globalEventName) {
    return events.get(globalEventName);
}
function getGlobalEventOrThrow(globalEventName) {
    const globalEvent = getGlobalEvent(globalEventName);
    if (globalEvent === undefined) {
        throw new Error(`global event ${globalEventName} not found`);
    }
    return globalEvent;
}
